import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Sidebar from './Sidebar';
import TopHeader from './TopHeader';

const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleMenuToggle = () => setMobileOpen((v) => !v);
  return (
    <div  className='d-flex w-100 layout-cover'>
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className='layout-right position-relative'>
        <TopHeader onMenuToggle={handleMenuToggle} />
        <main className='position-relative w-100'>
          {/* <Container fluid> */}
            <Outlet />
          {/* </Container> */}
        </main>
      </div>
    </div>
  );
};

export default Layout;
